import { AI_ENDPOINT, API_ENDPOINT } from '@Env/variables';
import { createAxiosInstance } from './axios';
import { AIFeatureKeys, AIFeatureSettings } from '@Models/types';

export const aiUsageAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, API_ENDPOINT);

  return {
    getTokenUsage: async () => {
      const res = await axios.get('/api/getTokenUsage');
      return res.data;
    },

    getUserTokenUsage: async (timeSpan: string) => {
      const res = await axios.get(
        `/api/getUserTokenUsage?timeSpan=${timeSpan}`
      );
      return res.data;
    },
  };
};

export const aiSettingsAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, AI_ENDPOINT);

  return {
    getAISettings: async (
      feature: AIFeatureKeys
    ): Promise<AIFeatureSettings> => {
      const { data } = await axios.get<{
        features: Record<string, AIFeatureSettings>;
      }>('/api/getAISettings', {
        params: { feature },
      });
      return data.features[feature];
    },

    updateAISettings: async (
      aiSettings: AIFeatureSettings | undefined,
      feature: AIFeatureKeys
    ) => {
      await axios
        .post('/api/updateAISettings', {
          bedRockModel: aiSettings?.bedRockModel,
          region: aiSettings?.region,
          temperature: aiSettings?.temperature,
          anthropicVersion: aiSettings?.anthropicVersion,
          maxTokens: aiSettings?.maxTokens,
          feature,
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
  };
};
